//src/utils/whatsappMessages.js
export const buildAbandonedCartWhatsAppMessage = ({
  name,
  cartLink,
}) => {
  const firstName = name ? name.split(" ")[0] : "";

  const message = `
Hello ${firstName},

You left some items in your cart at ETIKA 🛍️

Complete your order here:
${cartLink}

—
مرحباً ${firstName}

لقد تركت بعض المنتجات في سلة التسوق الخاصة بك في ETIKA 🛍️

يمكنك إكمال طلبك من هنا:
${cartLink}

If you need help, just reply to us.
ETIKA
  `.trim();

  return encodeURIComponent(message);
};

